import { ClientDashboardHistoricalJobOrderDto } from '@hoqus/connectis-client-dashboard-types';
import { HistoricalJobOrderType } from 'types/HistoricalJobOrder/HistoricalJobOrderType.ts';
import { mapDtoToJobOrderType } from 'types/JobOrder/mapper.ts';

export const mapDtoToHistoricalJobOrderType = (
  dto: ClientDashboardHistoricalJobOrderDto,
): HistoricalJobOrderType => ({
  ...mapDtoToJobOrderType(dto),
  hiredCount: dto.hiredCount,
});
